import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { motion } from "framer-motion";

const PropertyCardSkeleton = () => {
  return (
    <motion.div
      className="w-full max-w-[1515px] h-[473px] border-[1px] border-[#CCCCCCF2] rounded-[14px] pt-[27px] pr-[19px] pl-[26px] pb-[30px] flex items-center space-x-5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="w-[33.31%] h-full border-[1px] border-[#F0EFFB] rounded-[8px] overflow-hidden">
        <p className="h-1/2">
          <Skeleton height="100%" />
        </p>
        <div className="px-[29.88px] mt-3">
          <Skeleton width={130} height={30} />
          <Skeleton style={{ marginTop: 12 }} width="80%" height={30} />
          <Skeleton style={{ marginTop: 16 }} width={160} height={20} />
          <hr className="h-[1px] bg-[#F0EFFB] w-full mt-4 mb-[11px]" />
          <div className="flex items-center space-x-[24px]">
            <Skeleton width={70} height={30} />
            <Skeleton width={70} height={30} />
            <Skeleton width={70} height={30} />
          </div>
        </div>
      </div>
      <div className="w-[35.76%] bg-white border-[1px] border-[#F0EFFB] rounded-[9px] px-[12px] pt-[9px] h-full">
        <div className="h-[53px] rounded-[9px] bg-[#B2BCC230] py-[6px] px-[7px] flex items-center justify-between border-[0.2px] border-[#F7F7F7] space-x-3">
          <Skeleton width="100%" height={30} />
        </div>
        <div className="mt-[19px]">
          <Skeleton width="60%" height={40} />
          <Skeleton style={{ marginTop: 10 }} width="30%" height={20} />

          <hr className="mt-5 h-[1px] bg-[#E5E5EF] w-full mb-[10px]" />
          <Skeleton width="100%" height={210} />
        </div>
      </div>
      <div className="w-[28.21%] h-full">
        <div className="w-full h-[143px] rounded-[9px] border-[1px] border-[#F0EFFB] flex items-start justify-between">
          <div className="pl-[14px] pr-[15px] flex-1 pt-3">
            <Skeleton width={140} height={20} />
            <Skeleton style={{ marginTop: 20 }} width="100%" height={30} />
            <Skeleton style={{ marginTop: 10 }} width="80%" height={30} />
          </div>
        </div>

        <div className=" w-full h-[205px] rounded-[9px] mt-[9px] border-[1px] border-[#F0EFFB] flex items-start justify-between">
          <div className="pl-[14px] pr-[15px] flex-1 pt-3">
            <Skeleton width={140} height={20} />
            <Skeleton style={{ marginTop: 30 }} width="100%" height={30} />
            <Skeleton style={{ marginTop: 10 }} width="80%" height={30} />
            <Skeleton style={{ marginTop: 10 }} width="70%" height={30} />
          </div>
        </div>
        <div className="mt-2">
          <Skeleton width="100%" height={40} />
        </div>
      </div>
    </motion.div>
  );
};

export default PropertyCardSkeleton;
